import { featureAtom } from "@sunrise/feature-flags";

export const developerModeAtom = featureAtom("developer-mode", false, {
  description: `Shows the developer controls in the settings.`,
});
